import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  CircularProgress
} from '@mui/material';
import {
  Storage as StorageIcon
} from '@mui/icons-material';
import { useSelector } from 'react-redux';

function MCPServers() {
  const { user } = useSelector((state) => state.auth);
  
  // Extract MCP servers data from user object
  const mcpServers = user?.mcpServers || [];

    return (
    <Box sx={{ width: '100%', px: { xs: 0, sm: 0 } }}>
      {/* MCP Servers Content */}
      <Box sx={{ width: '100%' }}>
        {!user ? (
          <Box sx={{ 
            textAlign: 'center', 
            py: { xs: 3, sm: 4 },
            px: { xs: 1, sm: 2 }
          }}>
            <CircularProgress size={{ xs: 28, sm: 32 }} sx={{ mb: { xs: 0.75, sm: 1 } }} />
            <Typography variant="body2" sx={{ 
              color: '#6b7280',
              fontSize: { xs: '12px', sm: '14px' }
            }}>
              Loading user data...
            </Typography>
          </Box>
        ) : mcpServers.length > 0 ? (
          <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ width: '100%' }}>
            {mcpServers.map((server, index) => (
              <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4 }} key={server._id || index}>
                <Card sx={{ 
                  height: '100%',
                  width: '100%',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                  '&:hover': {
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    borderColor: '#d1d5db'
                  }
                }}>
                  <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 0.5, sm: 1 } }}>
                      <StorageIcon sx={{ 
                        fontSize: { xs: 18, sm: 20 }, 
                        color: '#6b7280', 
                        mr: { xs: 0.75, sm: 1 } 
                      }} />
                      <Typography variant="h6" sx={{ 
                        fontWeight: 600,
                        color: '#111827',
                        fontSize: { xs: '0.9rem', sm: '1rem' }
                      }}>
                        {server.name || 'Unnamed Server'}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ mb: { xs: 0.75, sm: 1 } }}>
                      <Typography variant="body2" sx={{ 
                        color: '#6b7280', 
                        mb: { xs: 0.25, sm: 0.25 },
                        fontWeight: 500,
                        fontSize: { xs: '11px', sm: '14px' }
                      }}>
                        Server URL:
                      </Typography>
                      <Typography variant="body2" sx={{ 
                        color: '#111827',
                        fontFamily: 'monospace',
                        fontSize: { xs: '11px', sm: '14px' },
                        wordBreak: 'break-all'
                      }}>
                        {server.url || 'No URL provided'}
                      </Typography>
                    </Box>

                    {server.storeUrl && (
                      <Box sx={{ mb: { xs: 0.75, sm: 1 } }}>
                        <Typography variant="body2" sx={{ 
                          color: '#6b7280', 
                          mb: { xs: 0.25, sm: 0.25 },
                          fontWeight: 500,
                          fontSize: { xs: '11px', sm: '14px' }
                        }}>
                          Store URL:
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#111827',
                          fontFamily: 'monospace',
                          fontSize: { xs: '11px', sm: '14px' }
                        }}>
                          {server.storeUrl}
                        </Typography>
                      </Box>
                    )}

                    {/* {server.elevenlabs_id && (
                      <Box sx={{ mb: { xs: 0.75, sm: 1 } }}>
                        <Typography variant="body2" sx={{ 
                          color: '#6b7280', 
                          mb: { xs: 0.25, sm: 0.25 },
                          fontWeight: 500,
                          fontSize: { xs: '11px', sm: '14px' }
                        }}>
                          ElevenLabs ID:
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: '#111827',
                          fontFamily: 'monospace',
                          fontSize: { xs: '11px', sm: '14px' }
                        }}>
                          {server.elevenlabs_id}
                        </Typography>
                      </Box>
                    )} */}

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Chip 
                        label="Active" 
                        color="success" 
                        size="small" 
                        variant="outlined"
                        sx={{
                          fontSize: { xs: '10px', sm: '12px' },
                          height: { xs: 20, sm: 24 }
                        }}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
                 ) : (
           <Box sx={{ 
             textAlign: 'center', 
             py: { xs: 3, sm: 4 },
             px: { xs: 1, sm: 2 }
           }}>
             <StorageIcon sx={{ 
               fontSize: { xs: 40, sm: 48 }, 
               color: '#9ca3af', 
               mb: { xs: 0.75, sm: 1 } 
             }} />
             <Typography variant="h6" sx={{ 
               color: '#6b7280', 
               mb: { xs: 0.5, sm: 0.5 },
               fontWeight: 600,
               fontSize: { xs: '1rem', sm: '1.125rem' }
             }}>
               No MCP Servers Found
             </Typography>
             <Typography variant="body2" sx={{ 
               color: '#9ca3af',
               maxWidth: 400,
               mx: 'auto',
               fontSize: { xs: '12px', sm: '14px' }
             }}>
               No MCP servers are currently configured for your agent. 
               MCP servers will appear here once they are added to your account.
             </Typography>
           </Box>
        )}
      </Box>
    </Box>
  );
}

export default MCPServers;
